// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

import EditIcon from '@mui/icons-material/Edit';
import BadgeIcon from '@mui/icons-material/Badge';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PersonIcon from '@mui/icons-material/Person';
import TabIcon from '@mui/icons-material/Tab';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SavingsIcon from '@mui/icons-material/Savings';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ChatIcon from '@mui/icons-material/Chat';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FolderIcon from '@mui/icons-material/Folder';
import { Icon } from '@iconify/react';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  edit:  <EditIcon />,
  student: <PersonIcon/>,
  tab: <TabIcon/>,
  documents: <Icon icon="mingcute:document-fill" width={22} height={22}/>,
  finance: <SavingsIcon/>,
  employee: <BadgeIcon/>,
  newEmployee: <AddCircleIcon/>,
  export: <FileDownloadIcon/>,
  newStudent: <PersonAddIcon/>,
  tagManagement: <LocalOfferIcon/>,
  projects: <AccountTreeIcon/>,
  chat: <ChatIcon/>,
  docs: <FolderIcon/>,
  dataSharing: <Icon icon="mdi:account-arrow-right" width={22} height={22}/>
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     { title: 'One', path: PATH_DASHBOARD.general.pageOne, icon: ICONS.dashboard },
  //     { title: 'Two', path: PATH_DASHBOARD.general.pageTwo, icon: ICONS.ecommerce },
  //     { title: 'Three', path: PATH_DASHBOARD.general.pageThree, icon: ICONS.analytics }
  //   ]
  // },
  {
    subheader: 'spectator menu',
    access: ['Spectator'],
    items: [
      { title: 'Overzicht Deelnemers', path: PATH_DASHBOARD.employee.students.root, icon: ICONS.student },
      { title: 'Projecten', path: PATH_DASHBOARD.employee.projects, icon: ICONS.projects },
      { title: 'Chat', path: PATH_DASHBOARD.employee.chat, icon: ICONS.chat },
    ]
  },
  {
    subheader: 'coach menu',
    access: ['Coach', 'Admin', 'SuperAdmin'],
    items: [
      { title: 'Dashboard', path: PATH_DASHBOARD.employee.dashboard, icon: ICONS.dashboard },
      // { title: 'Overzicht Studenten', path: PATH_DASHBOARD.employee.students.root, icon: ICONS.student },
      { title: 'Overzicht Deelnemers', path: PATH_DASHBOARD.employee.students.root, icon: ICONS.student },
      { title: 'Nieuwe Deelnemer', path: PATH_DASHBOARD.employee.studentCreator, icon: ICONS.newStudent },
      { title: 'Tags', path: PATH_DASHBOARD.employee.tagManagement, icon: ICONS.tagManagement },
      { title: 'Projecten', path: PATH_DASHBOARD.employee.projects, icon: ICONS.projects },
      { title: 'Chat', path: PATH_DASHBOARD.employee.chat, icon: ICONS.chat },
       ... window.location.hostname == "proof.projectboek.nl" ? [{ title: 'Documenten', path: PATH_DASHBOARD.employee.docs, icon: ICONS.docs }] : [],
    ], 
  },
  {
    subheader: 'verwijzer menu',
    access: ['Referrer'],
    items: [
      // { title: 'Dashboard', path: PATH_DASHBOARD.employee.dashboard, icon: ICONS.dashboard },
      { title: 'Overzicht Deelnemers', path: PATH_DASHBOARD.employee.students.root, icon: ICONS.student },
      { title: 'Nieuwe Deelnemer', path: PATH_DASHBOARD.employee.studentCreator, icon: ICONS.newStudent },
      { title: 'Projecten', path: PATH_DASHBOARD.employee.projects, icon: ICONS.projects },
      { title: 'Chat', path: PATH_DASHBOARD.employee.chat, icon: ICONS.chat },
    ], 
  },
  {
    subheader: 'admin',
    access: ['Admin', 'SuperAdmin'],
    items: [
      { title: 'Locatie Editor', path: PATH_DASHBOARD.admin.locationEditor, icon: ICONS.edit },
      { title: 'Budgetten', path: PATH_DASHBOARD.admin.budgets, icon: ICONS.finance },
      
      { title: 'Tab Editor', path: PATH_DASHBOARD.admin.tabEditorOverview, icon: ICONS.tab },
      { title: 'Overzicht Medewerkers', path: PATH_DASHBOARD.admin.employeeOverview, icon: ICONS.employee },
      { title: 'Nieuwe Medewerker', path: PATH_DASHBOARD.admin.newUser, icon: ICONS.newEmployee },
      { title: 'Overzicht Financiën', path: PATH_DASHBOARD.admin.financeOverview, icon: ICONS.finance },
      { title: 'Export Portaal', path: PATH_DASHBOARD.admin.exportPortal, icon: ICONS.export }
      
    ]
  },
  
  

  {
    subheader: 'MDT deelnemers',
    access: ['Student'],
    items: [
      // { title: 'Dashboard', path: PATH_DASHBOARD.student.dashboard, icon: ICONS.dashboard },
      {
        title: 'Tabbladen',
        path: PATH_DASHBOARD.student.taboverview,
        icon: ICONS.user,
        // children: [
        //   { title: 'Four', path: PATH_DASHBOARD.student.taboverview },
        //   { title: 'Five', path: PATH_DASHBOARD.student.taboverview },
        //   { title: 'Six', path: PATH_DASHBOARD.student.taboverview }
        // ]
      },
      { title: 'Documenten', path: PATH_DASHBOARD.student.documents, icon: ICONS.documents },
      { title: 'Financiën', path: PATH_DASHBOARD.student.financial, icon: ICONS.finance },
      { title: 'Projecten', path: PATH_DASHBOARD.student.projects, icon: ICONS.projects },
      { title: 'Gegevensuitwisseling', path: PATH_DASHBOARD.student.dataSharing, icon: ICONS.dataSharing },
      { title: 'Chat', path: PATH_DASHBOARD.student.chat, icon: ICONS.chat },
    ]
  },
  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.app.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'Four', path: PATH_DASHBOARD.app.pageFour },
  //         { title: 'Five', path: PATH_DASHBOARD.app.pageFive },
  //         { title: 'Six', path: PATH_DASHBOARD.app.pageSix }
  //       ]
  //     }
  //   ]
  // }
];

export default sidebarConfig;
